import { initializeApp } from 'firebase/app'
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  GoogleAuthProvider, // Already imported here
  sendPasswordResetEmail,
  updateEmail,
  linkWithPopup,
  signInWithPopup,
  getRedirectResult,
  OAuthProvider,
  signInWithPopup as signInWithPopupMicrosoft,
  connectAuthEmulator,
} from 'firebase/auth'
import {
  getFirestore,
  collection,
  doc,
  addDoc,
  setDoc,
  deleteDoc,
  onSnapshot,
  serverTimestamp,
  query,
  where,
  orderBy,
  getDocs,
  writeBatch,
  updateDoc,
  getDoc,
  connectFirestoreEmulator,
} from 'firebase/firestore'
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions'
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// --- Your original icon imports (restored) ---
import {
  Plus,
  Edit,
  Trash2,
  X,
  ChevronLeft,
  ChevronRight,
  User,
  LayoutGrid,
  List,
  Calendar as CalendarIcon,
  ArrowUp,
  ArrowDown,
  Inbox,
  Send,
  FileText,
  Archive,
  Mail,
  RefreshCw,
  CornerUpLeft,
  CornerUpRight,
  Tag,
  Search,
  Paperclip,
  Settings,
  Building,
  Briefcase,
  Users,
  UploadCloud,
  UserX,
  File,
  Printer,
  FileText as QuoteIcon,
  Bell,
} from 'lucide-react'

// ——— YOUR FIREBASE CONFIG ———
const firebaseConfig = {
  apiKey: 'AIzaSyARa2GgSRdiG05O0GhjVPFcfTJzdA9_l7M',
  authDomain: 'smb-suite-platform.firebaseapp.com',
  projectId: 'smb-suite-platform',
  storageBucket: 'smb-suite-platform.firebasestorage.app',
  messagingSenderId: '25729813177',
  appId: '1:25729813177:web:cb4eef969d8b8125826968'
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, 'us-central1');
const storage = getStorage(app);

// =====================================================
// START: Microsoft Provider Configuration
// =====================================================
const microsoftProvider = new OAuthProvider('microsoft.com');

// Define the scopes required for Email and Calendar access
const REQUIRED_MICROSOFT_SCOPES = [
    "User.Read",
    "Mail.ReadWrite", 
    "Mail.Send",      
    "Calendars.ReadWrite", 
    "offline_access"  
];

REQUIRED_MICROSOFT_SCOPES.forEach(scope => {
    microsoftProvider.addScope(scope);
});

microsoftProvider.setCustomParameters({
    prompt: 'consent'
});
// =====================================================
// END: Microsoft Provider Configuration
// =====================================================


// =====================================================
// START: Google Provider Configuration (NEW)
// =====================================================
const googleProvider = new GoogleAuthProvider();

// Optional: Add scopes if you want to access Google Calendar/Gmail later
googleProvider.addScope('https://www.googleapis.com/auth/userinfo.email');
googleProvider.addScope('https://www.googleapis.com/auth/userinfo.profile');
// =====================================================
// END: Google Provider Configuration
// =====================================================


// Updated exports to include googleProvider
export { 
  auth, 
  db, 
  functions, 
  storage, 
  app, 
  firebaseConfig, 
  microsoftProvider,
  googleProvider // <--- ADDED THIS!
};